import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../redux/hooks.js';
import { errorStatusSelector } from '../../registrationSlice.js';
export const RegistrationAlert = () => {
    const errorStatus = useAppSelector(errorStatusSelector);
    const { t } = useTranslation();
    const getLabel = () => {
        switch (errorStatus) {
            case 500:
                return t('loginregistration.registration.error.serverError');
            case 409:
            case 400:
                return t('loginregistration.registration.error.clientError');
            default:
                return t('loginregistration.registration.error.serverError');
        }
    };
    const label = getLabel();
    return (_jsx(_Fragment, { children: errorStatus && label ? (_jsx(Alert, { variant: 'negative', role: 'alert', children: label })) : null }));
};
//# sourceMappingURL=RegistrationAlert.js.map